import { FC } from "react"
import { useFormikContext } from "formik"
import { Integration } from "../../../../../types"
import Input from "../../../form/input"
import { HELP_TEXT_URL } from "../../../../constants"

interface Props {
  label?: string
}

const URLInput: FC<Props> = ({ label }) => {
  const { values } = useFormikContext<Integration>()
  return (
    <Input
      label={label ?? "URL"}
      name="url"
      placeholder="Ex. https://google.com/*"
      helpText={values.domains?.length === 0 ? HELP_TEXT_URL : ""}
    />
  )
}

export default URLInput
